
import dateFns from 'date-fns';
import moment from 'moment';

export function phoneFormatter(value: any, event: any): string {
    const val = (value === undefined || value === null) ? '' : value;
    const regExPhone = /^[\(]?(\d{1,3})?[\)]?[\s]?(\d{1,3})?[-]?(\d{1,4})?/;
    const arr: string[] | null = val.match(regExPhone);
    if ( arr !== null) {
        if (undefined !== arr[3]) {
            return '(' + arr[1] + ') ' + arr[2] + '-' + arr[3];
        } else if (undefined !== arr[2]) {
            return '(' + arr[1] + ') ' + arr[2];
        } else if (undefined !== arr[1]) {
            return '(' + arr[1];
        } else {
            return '';
        }
    }
    return '';
}

export function maxDigitsOfFiveNoNegative(value: any, event: any): number {
    const val: number = (value === undefined || value === null) ? 0 : Number(value);
    if (Number.isNaN(val) || val < 0) {
        return 0;
    } else if ( val > 99999) {
        return 99999;
    } else {
        return val;
    }
}

export function dateNotAheadOfTodayFormatter(value: any, event: any): string | null {
    if (typeof value === 'string' && value.length > 0) {
        if (dateFns.isValid(new Date(value)) && dateFns.isPast(new Date(value))) {
            return value;
        } else {
            alert('Date cannot be in the future.');
            return null;
        }
    } else {
        return null;
    }
}

export function phoneValidator(value: string | null | undefined): boolean | null {
    const regExPhone = /^\(\d{3}\)\s\d{3}-\d{4}$/;
    if (undefined === value || null === value || value.length === 0 ) {
        return null;
    } else {
        return regExPhone.test(value);
    }
}

export function dateFormatter(date: Date | string | number | null | undefined, format: string = 'MM/DD/YYYY'): string {
    const d = null === date || undefined === date || date instanceof Date ? date : new Date(date);
    return null === d || undefined === d ? '' : dateFns.format(dateFns.addMinutes(d, d.getTimezoneOffset()), format);
}

export function momentDateFormatter(value: Date | string | number | null | undefined): string {
    if (value !== undefined && value !== null) {
        if (moment(value).isValid()) {
            return moment(value).format('MM/DD/YYYY');
        } else {
            return '';
        }
    } else {
        return '';
    }
}

export function ucWords(text: string | null) {
    return (text || '').toLowerCase()
        .split('_')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}

/**
 * Formats date strings in YYYY-MM-DD that new Date() will give a UTC timezone to but dateFns
 * applies local timezone when formatting.
 * Returns MM/DD/YYYY
 * @param date Expecting a string of YYYY-MM-DD
 */
export function dateOnlyFormatter(date: string | null | undefined): string {
    const d = (undefined === date || null === date) ? undefined : new Date(date);
    return undefined === d ? '' : ('0' + (d.getUTCMonth() + 1)).slice(-2) + '/' + ('0' + d.getUTCDate()).slice(-2) + '/' +  d.getUTCFullYear();
}

export const FormatterPlugin = {
    install: (Vue: any) => {
        Vue.prototype.$phoneFormatter = phoneFormatter;
        Vue.prototype.$phoneValidator = phoneValidator;
        Vue.prototype.$dateFormatter = dateFormatter;
        Vue.prototype.$momentDateFormatter = momentDateFormatter;
        Vue.prototype.$dateOnlyFormatter = dateOnlyFormatter;
        Vue.prototype.$maxDigitsOfFiveNoNegative = maxDigitsOfFiveNoNegative;
        Vue.prototype.$dateNotAheadOfTodayFormatter = dateNotAheadOfTodayFormatter;
    }
};
